module.exports = __webpack_public_path__ + "static/media/mercedes_badge.346dc870.svg";